import { render, staticRenderFns } from "./ManageCentreModal.vue?vue&type=template&id=35f81cd6"
import script from "./ManageCentreModal.vue?vue&type=script&lang=js"
export * from "./ManageCentreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports